<template>
  <div class="top-menu">
    <div class="left">
      <a-icon class="icon" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="changeCollapsed" />
      <!--      <a-icon class="icon" type="reload" @click="refresh" />-->
      <!--      <el-breadcrumb separator="/">-->
      <!--        <el-breadcrumb-item v-for=" item in bread" :key="item.path" :to="{ path:item.path }">{{item.name}}</el-breadcrumb-item>-->
      <!--      </el-breadcrumb>-->

      <div class="logo">
        <span v-show="showLogo">拾光易租</span>
      </div>
    </div>

    <div class="right">
      <span>欢迎您：{{ name }}</span>
      <div class="logout" @click="logout">
        <a-icon class="icon" type="logout" />
        退出登录
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'TopMenu',
  model: {
    prop: 'collapsed'
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      userName: '',
      showLogo: true,
    }
  },

  created() {
    this.userName = localStorage.getItem('userName')
  },

  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo'
    }),
    ...mapState({ name: state => state.user.name }),
    bread(){
      let breadList = []
     breadList = this.$route.matched.map(item => {
          return {
            path: item.path,
            name: item.meta.name
          }
        })
      return breadList
    }
  },

  methods: {
    changeCollapsed() {
      this.$emit('input', !this.collapsed)
      this.$bus.$emit('showLogo')
    },

    refresh() {
      history.go(0)
    },

    logout() {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push('/login')
        // this.$store.dispatch('tagsView/delAllViews')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.top-menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  background: #ffffff;
  color: #303133;
  padding: 0 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  border-bottom: 1px solid #e4e7ed;
  position: relative;
  z-index: 1000;

  .icon {
    font-size: 18px;
    transition: all 0.25s ease;
  }

  .left {
    display: flex;
    align-items: center;
    gap: 20px;

    .icon {
      margin-right: 0;
      padding: 10px;
      border-radius: 6px;
      cursor: pointer;
      color: #606266;
      transition: all 0.25s ease;
      
      &:hover {
        background: #f5f7fa;
        color: #409EFF;
      }
      
      &:active {
        background: #ebedf0;
      }
    }

    .logo {
      display: flex;
      align-items: center;
      padding: 0;
      font-size: 18px;
      font-weight: 600;
      color: #303133;
      letter-spacing: 0.5px;
      position: relative;
      
      span {
        background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .logo__img {
        width: 30px;
        margin-right: 10px;
        border-radius: 4px;
      }
    }
  }

  .right {
    display: flex;
    align-items: center;
    gap: 20px;

    > span {
      color: #606266;
      font-size: 14px;
      font-weight: 500;
      padding: 6px 14px;
      background: #f5f7fa;
      border-radius: 6px;
      transition: all 0.25s ease;
      
      &:hover {
        background: #ebedf0;
        color: #303133;
      }
    }

    .icon {
      margin-left: 0;
      margin-right: 6px;
    }

    .logout {
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 8px 16px;
      border-radius: 6px;
      background: #fff;
      border: 1px solid #e4e7ed;
      color: #606266;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.25s ease;
      
      &:hover {
        background: #fef0f0;
        border-color: #fbc4c4;
        color: #f56c6c;
        
        .icon {
          color: #f56c6c;
        }
      }
      
      &:active {
        background: #fde2e2;
      }
      
      .icon {
        color: #909399;
        transition: all 0.25s ease;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .top-menu {
    padding: 0 16px;
    height: 56px;
    
    .left {
      gap: 12px;
      
      .logo span {
        font-size: 16px;
      }
    }
    
    .right {
      gap: 12px;
      
      > span {
        display: none;
      }
      
      .logout {
        padding: 6px 12px;
        font-size: 13px;
      }
    }
  }
}
</style>
